export enum CountryCode {
  /**
   * 台灣
   */
  TW = 'TW',
  /**
   * 美國
   */
  US = 'US',
  /**
   * 香港
   */
  HK = 'HK',
  /**
   * 新加坡
   */
  SG = 'SG',
  /**
   * 馬來西亞
   */
  MY = 'MY',
  /**
   * 澳門
   */
  MO = 'MO',
}

export const countryCodeMap = {
  [CountryCode.TW]: '台灣',
  [CountryCode.US]: '美國',
  [CountryCode.HK]: '香港',
  [CountryCode.SG]: '新加坡',
  [CountryCode.MY]: '馬來西亞',
  [CountryCode.MO]: '澳門',
} as const

export const PHONE_COUNTRY_CODE = {
  [CountryCode.TW]: '886',
  [CountryCode.US]: '1',
  [CountryCode.HK]: '852',
  [CountryCode.SG]: '65',
  [CountryCode.MY]: '60',
  [CountryCode.MO]: '853',
} as const

/**
 * 國家代碼對應的 IANA 時區
 * 用於時間顯示轉換，目前除了美國之外都是UTC+8
 */
export const COUNTRY_TIMEZONE: Record<CountryCode, string> = {
  [CountryCode.TW]: 'Asia/Taipei',
  [CountryCode.US]: 'America/Los_Angeles',
  [CountryCode.HK]: 'Asia/Hong_Kong',
  [CountryCode.SG]: 'Asia/Singapore',
  [CountryCode.MY]: 'Asia/Kuala_Lumpur',
  [CountryCode.MO]: 'Asia/Macau',
}

/**
 * 國家代碼對應幣別
 */
export const COUNTRY_CURRENCY_MAP: Record<CountryCode, string> = {
  [CountryCode.TW]: 'TWD',
  [CountryCode.HK]: 'HKD',
  [CountryCode.SG]: 'SGD',
  [CountryCode.MY]: 'MYR',
  [CountryCode.US]: 'USD',
  [CountryCode.MO]: 'HKD',
}

/**
 * 國家代碼對應顯示用幣別符號（前綴）
 * 跟 COUNTRY_CURRENCY_MAP（ISO code）不同：這支是給 UI 直接拼字串用，例如 `$50` / `RM50`
 */
export const COUNTRY_CURRENCY_SYMBOL_MAP: Record<CountryCode, string> = {
  [CountryCode.TW]: '$',
  [CountryCode.HK]: '$',
  [CountryCode.SG]: '$',
  [CountryCode.US]: '$',
  [CountryCode.MY]: 'RM',
  [CountryCode.MO]: '$',
}
